import myzod, { Infer } from 'myzod'
import { sessionSchema } from '../../entities/app/context/session'

export enum NotifyVia {
  EMAIL = 'Email',
  SMS = 'SMS',
  WEBSOCKET = 'Websocket',
}

export enum NotificationTemplate {
  ContractorCalendarRequest,
  UserCalendarRequest,
  CreditCardCharged,
  PaymentFailed,
}

export const notificationEventSchema = myzod.object({
  via: myzod.enum(NotifyVia),
  on: myzod?.string().optional(), // i.e. event is as a result of action "on" the following entity id
  templateType: myzod.enum(NotificationTemplate),
  initiatedBy: sessionSchema.or(myzod.literal('System')),
  templateData: myzod.unknown(),
  sendToUserId: myzod.string().pattern(/^User#/),
  skipNotificationCheck: myzod.boolean(),
})

export type NotificationEvent = Infer<typeof notificationEventSchema>
